export { ArticlePage } from './ArticlePage'
export type { ArticleData } from './ArticlePage'
